import { UserInfo } from '../user';

export enum EmployeeType {
    fullTime = 'fullTime',
    partTime = 'partTime',
}

export interface Creator extends UserInfo {
    organizationId: string;
    profile: CreatorProfile;
    email: string;
    phoneNumber?: string;
    roleIds?: string[];
    organizationAdmin?: boolean;
    department?: string;
    departmentGroupId?: string | null;
    employeeType?: EmployeeType;
}
interface CreatorProfile {
    firstName: string;
    lastName: string;
    avatar?: string;
}
